import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import type { SxProps } from "@mui/material/styles";
import useTheme from "@mui/material/styles/useTheme";

import { colord } from "colord";

type HeaderDetailTooltipProps = {
  children?: React.ReactNode;
  tooltip?: React.ReactNode;
  placement?:
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";
  disableTooltip?: boolean;
  sx?: SxProps;
};

export default function HeaderDetailTooltip({
  tooltip,
  placement,
  disableTooltip,
  sx,
  children
}: HeaderDetailTooltipProps) {
  const { palette, shadows } = useTheme();
  const hoverSx = {
    "&:hover": {
      borderRadius: "4px",
      background: !disableTooltip
        ? colord(palette.patientHeader.main).darken(0.03).toHex()
        : undefined
    }
  };
  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: {
            color: "common.black",
            bgcolor: "common.white",
            opacity: 1,
            boxShadow: shadows[3],
            minWidth: "450px",
            borderRadius: "12px",
            ...sx
          }
        }
      }}
      disableFocusListener
      placement={placement}
      title={disableTooltip ? null : <Box sx={{ p: 2 }}>{tooltip}</Box>}
      PopperProps={{
        sx: {
          zIndex: 10
        }
      }}
    >
      <Box sx={{ cursor: "default", ...hoverSx }}>{children}</Box>
    </Tooltip>
  );
}
